import { Modal } from '@mui/material'
import React from 'react'
import SanitizeHtml from '../SanitizeHtml/SanitizeHtml'

const ErrorModal = ({ open, onClose, errorMessages, closeText }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableScrollLock={true}>
      <div className="b-error-modal">
        <button
          type="button"
          aria-label={closeText || 'close'}
          className="btn p-0 b-error-modal__close"
          onClick={onClose}>
          <i className="icon-x"></i>
        </button>

        <div className="b-error-modal__body">
          {errorMessages.map((message, index) => (
            <SanitizeHtml key={index} html={message} />
          ))}
        </div>
      </div>
    </Modal>
  )
}

export default ErrorModal
